window.theme = window.theme || {};

theme.QuickAdd = (function() {
  function QuickAdd() {
    this.init();
  }

  QuickAdd.prototype = Object.assign({}, QuickAdd.prototype, {
    init: function() {
      this.bindEvents();
    },

    bindEvents: function() {
      console.log('QuickAdd bindEvents called');
      $('body').on('click', '.quick-add-icon', function(e) {
        e.preventDefault();
        e.stopPropagation();
        console.log('QuickAdd click detected');

        var href = $(this).data('handle');
        console.log('Product handle:', href);
        
        if (window.ella && typeof window.ella.doAjaxShowQuickView === 'function') {
          window.ella.doAjaxShowQuickView(href);
          window.ella.closeSuccessModal();
        } else {
          console.error('ella.doAjaxShowQuickView is not available');
        }
      });
    }
  });

  return QuickAdd;
})();

$(document).ready(function() {
  // Initialize QuickAdd
  theme.quickAdd = new theme.QuickAdd();
});
